webpackJsonp([3],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _nav = __webpack_require__("./src/components/nav/nav.js");
	
	var _nav2 = _interopRequireDefault(_nav);
	
	__webpack_require__("./src/styles/main.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: "DSA Momentum",
	          meta: [{
	            name: "description",
	            content: "For a Mass Socialist Movement in the United States"
	          }, {
	            name: "keywords",
	            content: "socialism, democratic socialism, DSA"
	          }, {
	            name: "twitter:card",
	            content: "summary_large_image"
	          }, {
	            name: "twitter:site",
	            content: "@DSA_Momentum"
	          }, {
	            name: "twitter:title",
	            content: "DSA Momentum"
	          }, {
	            name: "twitter:description",
	            content: "For a Mass Socialist Movement in the United States"
	          }, {
	            name: "twitter:image",
	            content: "https://s3.amazonaws.com/dsamomentum/dsamomentum.png"
	          }, {
	            name: "twitter:image:alt",
	            content: "Design and Illustration by Colleen Tighe"
	          }, {
	            property: "og:url",
	            content: "http://www.dsamomentum.org/"
	          }, {
	            property: "og:type",
	            content: "website"
	          }, {
	            property: "og:title",
	            content: "DSA Momentum"
	          }, {
	            property: "og:description",
	            content: "For a Mass Socialist Movement in the United States"
	          }, {
	            property: "og:image",
	            content: "https://s3.amazonaws.com/dsamomentum/dsamomentum.png"
	          }]
	        }),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "0 auto",
	              maxWidth: 960,
	              padding: "0px 1.0875rem",
	              paddingTop: 0
	            }
	          },
	          this.props.children()
	        )
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _propTypes2.default.func
	};
	exports.default = Template;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/styles/main.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// layout-component---index-60143690d0b0d903ebe4.js